/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
function toggleStepImage(activeStep, index) {
  if (activeStep && activeStep?.toLowerCase() == "yes") {
    document.querySelector(
      `.step_image[data-index-image='${index}']`
    ).style.display = "block";
  } else {
    // Hide the image if "No" is selected
    document.querySelector(
      `.step_image[data-index-image='${index}']`
    ).style.display = "none";
  }
}

// function filterSlide(filterCriteria, dataIndex) {
//   console.log("criteriaLowercriteriaLowercriteriaLowercriteriaLowercriteriaLower")
//   let criteriaLower = filterCriteria?.toLowerCase();
//   if ($(".product-image-slider-nav").hasClass("slick-initialized")) {
//     $(".product-image-slider-nav").slick("slickUnfilter");
//   }
//   if ($(".product-image-slider").hasClass("slick-initialized")) {
//     $(".product-image-slider").slick("slickUnfilter");
//   }
//   $(".product-image-slider-nav").slick("slickFilter", `.${criteriaLower}`);
//   $(".product-image-slider").slick("slickFilter", `.${criteriaLower}`);
//   $(".product-image-slider-nav").slick("refresh");
//   $(".product-image-slider").slick("refresh");
//   if (dataIndex) {
//     $(
//       `.product-image-slider-nav[data-toggle-index="${dataIndex}"]`
//     ).removeClass("hidden");
//     $(`.product-image-slider[data-toggle-index="${dataIndex}"]`).removeClass(
//       "hidden"
//     );
//   }
// }

function filterSlide(filterCriteria, dataIndex, filterCriteria2) {
  let criteriaLower = filterCriteria?.toLowerCase().replace(/\s+/g, '-');  
  let criteriaLower2 = filterCriteria2?.toLowerCase().replace(/\s+/g, '-');
  if ($('.product-image-slider-nav').hasClass('slick-initialized')) {
    $('.product-image-slider-nav').slick('slickUnfilter');
  }
  if ($('.product-image-slider').hasClass('slick-initialized')) {
    $('.product-image-slider').slick('slickUnfilter');
  }
  let filterString = `.${criteriaLower}`;
  if (criteriaLower2) {
    filterString += `, .${criteriaLower}-${criteriaLower2}`; 
  }

  $('.product-image-slider-nav').slick('slickFilter', filterString);
  $('.product-image-slider').slick('slickFilter', filterString);

  $('.product-image-slider-nav').slick('refresh').slick('slickGoTo', 0);
  $('.product-image-slider').slick('refresh').slick('slickGoTo', 0);
    if (dataIndex) {
    $(
      `.product-image-slider-nav[data-toggle-index="${dataIndex}"]`
    ).removeClass("hidden");
    $(`.product-image-slider[data-toggle-index="${dataIndex}"]`).removeClass(
      "hidden"
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  function isArabicURL() {
    return window.location.href.includes("/ar/");
  }

  const commonSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".product-image-slider-nav",
    adaptiveHeight: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          dots: true,
          arrows: true,
          prevArrow:
            '<button type="button" class="slick-prev pull-left"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next pull-right"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg></button>',
        },
      },
    ],
  };

  let productWrapper = document.querySelector(".product__wrapper") ||  document.querySelector(".product[data-position]");
  const navSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".product-image-slider",
    centerMode: false,
    focusOnSelect: true,
    arrows: true,
    adaptiveHeight: true,
    vertical: !productWrapper || productWrapper.dataset.position != "bottom",
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };

  // console.log("navSettings", navSettings)

  if (isArabicURL()) {
    commonSettings.rtl = true;
  }

  $(".product-image-slider").slick(commonSettings);
  $(".product-image-slider-nav").slick(navSettings);

  const calculateAndFormatPrice = (price1, price2) => {
    const value = (parseFloat(price1) - parseFloat(price2)) / 100;
    return value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const productListSelect = document.querySelector(".product-list__select");

  if (productListSelect) {
    if (productListSelect.value.includes("Oval Plunge")) {
      document.querySelector(
        `[name="properties[_Product_compare_at_price]"]`
      ).value = window.addonProdMetaPrice["oval Plunge"][0];
      if (
        document.querySelector(
          ".product-meta__price-list-container .price.price--compare .money"
        )
      ) {
        document.querySelector(
          ".product-meta__price-list-container .price.price--compare .money"
        ).innerHTML = window.addonProdMetaPrice["oval Plunge"][0];
      }
      if (
        document.querySelector(
          ".product-meta__price-list-container .product-meta__label-list .money"
        )
      ) {
        document.querySelector(
          ".product-meta__price-list-container .product-meta__label-list .money"
        ).innerHTML = window.moneyFormat.replace(
          "{{amount}}",
          calculateAndFormatPrice(
            window.addonProdMetaPrice["oval Plunge"][1],
            window.addonProdMetaPrice["original price"]
          )
        );
      }
    } else if (productListSelect.value.includes("Barrel Plunge")) {
      document.querySelector(
        `[name="properties[_Product_compare_at_price]"]`
      ).value = window.addonProdMetaPrice["barrel Plunge"][0];
      if (
        document.querySelector(
          ".product-meta__price-list-container .price.price--compare .money"
        )
      ) {
        document.querySelector(
          ".product-meta__price-list-container .price.price--compare .money"
        ).innerHTML = window.addonProdMetaPrice["barrel Plunge"][0];
      }
      if (
        document.querySelector(
          ".product-meta__price-list-container .product-meta__label-list .money"
        )
      ) {
        document.querySelector(
          ".product-meta__price-list-container .product-meta__label-list .money"
        ).innerHTML = window.moneyFormat.replace(
          "{{amount}}",
          calculateAndFormatPrice(
            window.addonProdMetaPrice["barrel Plunge"][1],
            window.addonProdMetaPrice["original price"]
          )
        );
      }
    }
  }

  if (productListSelect) {
    productListSelect.addEventListener("change", function (e) {
      let checkedInputs = document.querySelectorAll(".block-swatch__radio-bundle:checked");
      if (checkedInputs.length > 0) {
        let checkedValues = Array.from(checkedInputs).map(input => input.value);
        let joinedValues = checkedValues.join('/');
        window.checkedValue = joinedValues;
      }
      if (e.currentTarget.value.includes("Oval Plunge")) {
        document.querySelector(
          `[name="properties[_Product_compare_at_price]"]`
        ).value = window.addonProdMetaPrice["oval Plunge"][0];
        if (
          document.querySelector(
            ".product-meta__price-list-container .price.price--compare .money"
          )
        ) {
          document.querySelector(
            ".product-meta__price-list-container .price.price--compare .money"
          ).innerHTML = window.addonProdMetaPrice["oval Plunge"][0];
        }
        if (
          document.querySelector(
            ".product-meta__price-list-container .product-meta__label-list .money"
          )
        ) {
          document.querySelector(
            ".product-meta__price-list-container .product-meta__label-list .money"
          ).innerHTML = window.moneyFormat.replace(
            "{{amount}}",
            calculateAndFormatPrice(
              window.addonProdMetaPrice["oval Plunge"][1],
              window.addonProdMetaPrice["original price"]
            )
          );
        }
      } else if (e.currentTarget.value.includes("Barrel Plunge")) {
        document.querySelector(
          `[name="properties[_Product_compare_at_price]"]`
        ).value = window.addonProdMetaPrice["barrel Plunge"][0];
        if (
          document.querySelector(
            ".product-meta__price-list-container .price.price--compare .money"
          )
        ) {
          document.querySelector(
            ".product-meta__price-list-container .price.price--compare .money"
          ).innerHTML = window.addonProdMetaPrice["barrel Plunge"][0];
        }
        if (
          document.querySelector(
            ".product-meta__price-list-container .product-meta__label-list .money"
          )
        ) {
          document.querySelector(
            ".product-meta__price-list-container .product-meta__label-list .money"
          ).innerHTML = window.moneyFormat.replace(
            "{{amount}}",
            calculateAndFormatPrice(
              window.addonProdMetaPrice["barrel Plunge"][1],
              window.addonProdMetaPrice["original price"]
            )
          );
        }
      }

      let selectedOption =
        productListSelect.options[productListSelect.selectedIndex];
      let dataValue = selectedOption.value;
      let dataIndex = selectedOption.getAttribute("data-index");
      let inputSubData = document.querySelector(
        'input[name="properties[Product]"]'
      );
      if (inputSubData) {
        inputSubData.value = dataValue;
      }
      const dataToggleIndexElements = document.querySelectorAll(
        "[data-toggle-index]"
      );


      if (dataToggleIndexElements) {
        dataToggleIndexElements.forEach(function (element) {
          element.classList.add("hidden");
        });
        dataToggleIndexElements.forEach(function (element) {
          let indexValue = element.getAttribute("data-toggle-index");
          if (indexValue == dataIndex) {
            element.classList.remove("hidden");
            let optionSelectors = document.querySelectorAll(
              ".product-form__option-selector"
            );
            optionSelectors.forEach(function (selector) {
              if (!selector.classList.contains("hidden")) {
                let activeButton = selector.querySelector(
                  ".color-swatch__radio-btn.active"
                );
                if (activeButton) {
                  updateProductFormColor(activeButton, dataIndex);
                }
                selector
                  .querySelectorAll(".color-swatch__radio-btn")
                  .forEach(function (button) {
                    button.addEventListener("click", function () {
                      selector
                        .querySelectorAll(".color-swatch__radio-btn")
                        .forEach(function (btn) {
                          btn.classList.remove("active");
                        });
                      button.classList.add("active");
                      updateProductFormColor(button, dataIndex);
                    });
                  });

                let activeStepButton = selector.querySelector(
                  ".block-swatch__radio_step.active"
                );
                if (activeStepButton) {
                  const activebuttonAttribute =
                    activeStepButton.getAttribute("data-value");
                  let toggleIndex = selector.getAttribute("data-toggle-index");
                  updateProductFormColor(activeStepButton, toggleIndex);
                }

                selector
                  .querySelectorAll(".block-swatch__radio_step")
                  .forEach(function (button) {
                    button.addEventListener("click", function () {
                      selector
                        .querySelectorAll(".block-swatch__radio_step")
                        .forEach(function (btn) {
                          btn.classList.remove("active");
                        });
                      button.classList.add("active");
                      const buttonAttribute = button.getAttribute("data-value");
                      let toggleIndex =
                        selector.getAttribute("data-toggle-index");
                      updateProductFormColor(button, toggleIndex);
                    });
                  });
              }
            });
          } else {
            element.classList.add("hidden");
          }
        });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-header").forEach((header) => {
    header.addEventListener("click", function () {
      this.nextElementSibling.classList.toggle("active");
      this.classList.toggle("active");
    });
  });

  let optionSelectors = document.querySelectorAll(
    ".product-form__option-selector"
  );

  optionSelectors.forEach(function (selector) {
    if (!selector.classList.contains("hidden")) {
      let activeButton = selector.querySelector(
        ".color-swatch__radio-btn.active"
      );
      if (activeButton) {
        const activebuttonAttribute = activeButton.getAttribute("data-value");
        let toggleIndex = selector.getAttribute("data-toggle-index");
        updateProductFormColor(activeButton, toggleIndex);
      }

      selector
        .querySelectorAll(".color-swatch__radio-btn")
        .forEach(function (button) {
          button.addEventListener("click", function () {
            selector
              .querySelectorAll(".color-swatch__radio-btn")
              .forEach(function (btn) {
                btn.classList.remove("active");
              });
            button.classList.add("active");
            const buttonAttribute = button.getAttribute("data-value");
            let toggleIndex = selector.getAttribute("data-toggle-index");
            updateProductFormColor(button, toggleIndex);
          });
        });

      let activeStepButton = selector.querySelector(
        ".block-swatch__radio_step.active"
      );
      if (activeStepButton) {
        const activebuttonAttribute =
          activeStepButton.getAttribute("data-value");
        let toggleIndex = selector.getAttribute("data-toggle-index");
        updateProductFormColor(activeStepButton, toggleIndex);
      }

      selector
        .querySelectorAll(".block-swatch__radio_step")
        .forEach(function (button) {
          button.addEventListener("click", function () {
            selector
              .querySelectorAll(".block-swatch__radio_step")
              .forEach(function (btn) {
                btn.classList.remove("active");
              });
            button.classList.add("active");
            const buttonAttribute = button.getAttribute("data-value");
            let toggleIndex = selector.getAttribute("data-toggle-index");
            updateProductFormColor(button, toggleIndex);
          });
        });
    }
  });

  const previewBox = document.querySelector('.mega-menu__hover-preview');
  const defaultImages = document.querySelector('.mega-menu__default-images');
  const hoverLink = previewBox?.querySelector('.mega-menu__hover-link');
  const hoverImage = previewBox?.querySelector('.mega-menu__hover-image');
  const hoverTitle = previewBox?.querySelector('.mega-menu__hover-title');
  const hoverPrice = previewBox?.querySelector('.mega-menu__hover-price');

  let hideTimeout;

  function showPreview(item) {
    const image = item.dataset.productImage;
    const title = item.dataset.productTitle;
    const price = item.dataset.productPrice;
    const url = item.dataset.productUrl;

    if (image && image !== '') {
      // Only change if different
      if (hoverImage.src !== image) {
        hoverImage.style.opacity = 0;
        hoverImage.onload = () => {
          hoverImage.style.opacity = 1;
        };
        hoverImage.src = image;
      }

      hoverImage.alt = title || '';
      hoverTitle.textContent = title || '';
      hoverPrice.textContent = price || '';
      hoverLink.href = url || '#';

      previewBox.hidden = false;
      if (defaultImages) defaultImages.hidden = true;
    } else {
      previewBox.hidden = true;
      if (defaultImages) defaultImages.hidden = false;
    }
  }

  function scheduleHidePreview() {
    hideTimeout = setTimeout(() => {
      previewBox.hidden = true;
      if (defaultImages) defaultImages.hidden = false;
    }, 150);
  }

  function cancelHidePreview() {
    clearTimeout(hideTimeout);
  }

  // Preload images to avoid flicker
  document.querySelectorAll('.linklist__item').forEach(item => {
    const image = item.dataset.productImage;
    if (image) {
      const preload = new Image();
      preload.src = image;
    }

    item.addEventListener('mouseenter', () => {
      cancelHidePreview();
      showPreview(item);
    });

    item.addEventListener('mouseleave', () => {
      scheduleHidePreview();
    });
  });

  previewBox.addEventListener('mouseenter', cancelHidePreview);
  previewBox.addEventListener('mouseleave', scheduleHidePreview);

});
// let checkedInput = document.querySelector(
//   ".block-swatch__radio-bundle:checked"
// );
// if (checkedInput) {
//   window.checkedValue = checkedInput.value;
// }
let checkedInputs = document.querySelectorAll(".block-swatch__radio-bundle:checked");
if (checkedInputs.length > 0) {
  let checkedValues = Array.from(checkedInputs).map(input => input.value);
  let joinedValues = checkedValues.join('/');
  window.checkedValue = joinedValues;
}

function updateProductFormColor(button, dataIndex) {
  console.log('Color Filtered');
  if (button.classList.contains("steps")) {
    let stepValue = button.getAttribute("data-value");
    window.stepValue = stepValue;
    toggleStepImage(window.stepValue, dataIndex);
  } else {
    let colorValue = button.getAttribute("data-value");
    window.colorValue = colorValue;
    const variantScript = document.querySelector(
      ".product-form__option-selector:not(.hidden) .variantmedia"
    );
    if (variantScript) {
      const variantData = JSON.parse(variantScript?.textContent.trim());
      variantData?.forEach((variant) => {
        if (variant?.alt?.toLowerCase() === colorValue?.toLowerCase()) {
          let variantTitle = colorValue;
          if (variantTitle) {
            
            let selectedValue = document.querySelector(".main-product-data input[type='radio']:checked").value;
            let formattedValue = selectedValue.toLowerCase()
            .replace(/\s+/g, '-')   // replace spaces with hyphens
            .replace(/\./g, '-');   // replace periods with hyphens

            filterSlide(variantTitle, dataIndex, formattedValue);
          }
        }

        const { variant_id, variant_title } = variant;
        if (
          variant?.featured_image &&
          variant?.title.toLowerCase().includes(colorValue?.toLowerCase())
        ) {
          let variantTitle = variant?.title;
          if (variantTitle) {
            setTimeout(function () {
            let selectedValue = document.querySelector(".main-product-data input[type='radio']:checked").value;
            let formattedValue = selectedValue.toLowerCase()
            .replace(/\s+/g, '-')   // replace spaces with hyphens
            .replace(/\./g, '-');   // replace periods with hyphens
              filterSlide(variantTitle, dataIndex, formattedValue);
            }, 1000);
          }
        }
      });
    }
  }

  let form = document.querySelector(`.product-form__buy-buttons form`);
  if (form) {
    let colorInput = form.querySelector('input[name="properties[Color]"]');
    if (colorInput) {   
      if (typeof window.stepValue != 'undefined'){
      colorInput.value =
        colorValue + "/" + window.stepValue + "/" + window.checkedValue;       
      }else{
      colorInput.value =
        colorValue + "/" + window.checkedValue;
      }
    } else {
      colorInput = document.createElement("input");
      colorInput.type = "hidden";
      colorInput.name = "properties[Color]";
       if (typeof window.stepValue != 'undefined'){      
      colorInput.value =
        colorValue + "/" + window.stepValue + "/" + window.checkedValue;
       }else{
          colorInput.value =
        colorValue + "/" + window.checkedValue;  
       }
      form.appendChild(colorInput);
    }
  }
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function(e) {
    e.preventDefault();
    
    // Get the section ID from the href attribute
    const sectionID = this.getAttribute("href");
    const section = document.querySelector(sectionID);
    
    // Check if the section exists
    if (section) {
      // Calculate the scroll position with offset for sticky header
      const headerOffset = document.querySelector(".header").offsetHeight;
      const extraOffset = 50; // Adjust this value as needed
      const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - headerOffset - extraOffset;
      
      // Scroll to the position with smooth behavior
      window.scrollTo({
        top: sectionPosition,
        behavior: "smooth"
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("hulkFormPopup");
  const closeBtn = popup.querySelector(".hulk-close");

  document.querySelectorAll(".open-hulk-form").forEach(btn => {
    btn.addEventListener("click", () => popup.style.display = "flex");
  });

  closeBtn.addEventListener("click", () => popup.style.display = "none");
  window.addEventListener("click", (e) => {
    if (e.target === popup) popup.style.display = "none";
  });
});

document.addEventListener("click", function(e) {
  if (!e.target.classList.contains("color-swatch__radio")) return;

  const selectedValue = e.target.getAttribute("data-value");
  const bindId = e.target.getAttribute("data-bind-value");
  if (!bindId || !selectedValue) return;

  const valueElement = document.getElementById(bindId);
  if (valueElement) {
    valueElement.textContent = selectedValue;
  }
  const optionBlock = e.target.closest(".color-swatch-list");
  if (optionBlock) {
    optionBlock.querySelectorAll(".color-swatch__radio").forEach(btn => btn.classList.remove("active"));
    e.target.classList.add("active");
  }
});

(function () {
  const listItems = document.querySelectorAll('.key__benefits--list-item');
  const imageItems = document.querySelectorAll('.key__benefits--images-list');
  if (!listItems.length || !imageItems.length) return;

  function activateByIndex(index) {
    listItems.forEach(el => el.classList.remove('active'));
    imageItems.forEach(el => el.classList.remove('active'));

    if (listItems[index]) listItems[index].classList.add('active');
    if (imageItems[index]) imageItems[index].classList.add('active');
  }

  listItems.forEach((item, index) => {
    // Mouse hover
    item.addEventListener('mouseenter', () => activateByIndex(index));

    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        const isAnyHovered = Array.from(listItems).some(el => el.matches(':hover'));
        if (!isAnyHovered) {
          activateByIndex(0);
        }
      }, 50);
    });

    // Touch / click
    item.addEventListener('click', (e) => {
      e.preventDefault(); // avoid unwanted navigation if it's a link
      activateByIndex(index);
    });
  });

  activateByIndex(0);
})();


function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  requestAnimationFrame(() => {
    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

function initMatchHeight() {
  matchHeight('.how__to--use-step-description');
  matchHeight('.section__need--desc');
  matchHeight('.section__need--title');
  matchHeight('.how__to--use-step-icon');
  matchHeight('.key__feature--description');
  matchHeight('.key__feature--title');
}

document.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('load', initMatchHeight);
window.addEventListener('resize', () => {
  clearTimeout(window._mhTimer);
  window._mhTimer = setTimeout(initMatchHeight, 100);
});

(function () {
  function ensureSwiperReady(next) {
    if (typeof Swiper !== 'undefined') {
      next();
      return;
    }
    setTimeout(() => ensureSwiperReady(next), 150);
  }

  function initKeyFeaturesSlider() {
    const containers = document.querySelectorAll('.key__features--swiper');
    if (!containers.length) return;

    ensureSwiperReady(() => {
      containers.forEach((container) => {
        if (container.swiper) return;

        const scrollbarEl = container.querySelector('.swiper-scrollbar') || '.swiper-scrollbar';

        new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 15,
          scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },
          breakpoints: {
            640: { slidesPerView: 2 },
            741: { slidesPerView: 2.6 },
            1024: { slidesPerView: 3.55, spaceBetween: 15 },
            1280: { slidesPerView: 3.55, spaceBetween: 30 },
          },
          loop: false,
          grabCursor: true,
        });
      });
    });
  }

  function initPopularProductSlider() {
    const sliders = document.querySelectorAll('.popular__products--slider');
    if (!sliders.length) return;

    ensureSwiperReady(() => {
      sliders.forEach((slider) => {
        if (slider.swiper) return;

        const scrollbarEl = slider.querySelector('.swiper-scrollbar') || '.swiper-scrollbar';

        new Swiper(slider, {
          slidesPerView: 1.3,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          loopFillGroupBlank: false,
          grabCursor: true,
          slidesOffsetAfter: 0,
          loopFillGroupWithBlank: true,
          scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },
          breakpoints: {
            567: { slidesPerView: 2 },
            741: { slidesPerView: 2.5 },
            1024: { slidesPerView: 2.9 },
            1440: { slidesPerView: 3.5, spaceBetween: 30 },
          },
        });
      });

      if (typeof matchHeight === 'function') {
        matchHeight('.product-item-meta__title');
      }
    });
  }

  function initHowToUseSlider() {
    const sliders = document.querySelectorAll('.how__to--use-slider');
    if (!sliders.length) return;

    ensureSwiperReady(() => {
      sliders.forEach((slider) => {
        if (slider.swiper) return;

        new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          loop: true,
          navigation: {
            nextEl: '.how__to--use-next',
            prevEl: '.how__to--use-prev',
          },
          breakpoints: {
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1280: { slidesPerView: 5, spaceBetween: 10 },
          },
          on: {
            init: function () {
              setTimeout(() => {
                if (typeof matchHeight === 'function') {
                  matchHeight('.how__to--use-step-description');
                  matchHeight('.how__to--use-step-icon');
                }
              }, 50);
            },
            resize: function () {
              setTimeout(() => {
                if (typeof matchHeight === 'function') {
                  matchHeight('.how__to--use-step-description');
                  matchHeight('.how__to--use-step-icon');
                }
              }, 50);
            },
          },
        });
      });
    });
  }

  function initBrandSlider() {
    const sliders = document.querySelectorAll(".brand__slider");

    if (!sliders.length) {
      console.error("No .brand__slider elements found!");
      return;
    }

    sliders.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 20,
        // loop: true,
        // loopAdditionalSlides: 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        breakpoints: {
          740: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 7
          }
        }
      });
    });    
  }

  function initNeedsSlider() {
    const sliders = document.querySelectorAll(".section__need--slider");
    sliders.forEach((slider) => {
      if (!slider.swiper) {
        new Swiper(slider, {
          slidesPerView: 'auto',
          loop: false,
          grabCursor: true
        });
      }
    });
    matchHeight('.section__need--desc');
  }




  function initAllSwipers() {
    initKeyFeaturesSlider();
    initPopularProductSlider();
    initHowToUseSlider();
    initBrandSlider();
    initNeedsSlider();
  }

  document.addEventListener('DOMContentLoaded', initAllSwipers);
  window.addEventListener('load', initAllSwipers);

  document.addEventListener('shopify:section:load', function (event) {
    // Re-run on any section load; guards inside will prevent double init
    initAllSwipers();
  });

  // Expose for manual re-init if needed from console
  window.initKeyFeaturesSlider = initKeyFeaturesSlider;
  window.initPopularProductSlider = initPopularProductSlider;
  window.initHowToUseSlider = initHowToUseSlider;
  window.initBrandSlider = initBrandSlider;
  window.initNeedsSlider = initNeedsSlider;

})();

function updateKeySpecifications(variantId) {
  const section = document.querySelector('[data-key-specifications]');
  if (!section) return;

  const variantIdString = String(variantId);
  const rows = section.querySelectorAll('[data-key-spec-variant]');
  if (!rows.length) return;

  let matched = false;

  rows.forEach((row) => {
    if (row.dataset.keySpecVariant === variantIdString) {
      matched = true;
    }
  });

  if (!matched) return;

  rows.forEach((row) => {
    row.hidden = row.dataset.keySpecVariant !== variantIdString;
  });

  section.hidden = false;
}

document.addEventListener('variant:changed', function (event) {
  if (!event.detail?.variant?.id) return;
  updateKeySpecifications(event.detail.variant.id);
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('[data-key-specifications]');
  if (!section) return;

  const variantInput = document.querySelector(
    '.shopify-section--main-product form[is="product-form"] [name="id"]'
  );

  if (variantInput?.value) {
    updateKeySpecifications(variantInput.value);
  }
});